'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamor = require('glamor');

var _isArray = require('lodash/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

var _isString = require('lodash/isString');

var _isString2 = _interopRequireDefault(_isString);

var _disqusReact = require('disqus-react');

var _disqusReact2 = _interopRequireDefault(_disqusReact);

var _collapse = require('antd/lib/collapse');

var _collapse2 = _interopRequireDefault(_collapse);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // import '@bodhi-project/antrd/lib/restorative-auroville/3.10.0/collapse/style/css'
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Locals
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstractions
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Components


var Fragment = _react2.default.Fragment; // ------------------------------------------------------------------------------
// ---------------------------------------------------------------------- Imports
// ------------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries

var Panel = _collapse2.default.Panel; // ----------------------------------------------------------------------------
// --------------------------------------------------------------------- Styles
// ----------------------------------------------------------------------------

var defaultStyle = (0, _glamor.css)({
  '& .ant-collapse-header': {
    display: 'flex',
    alignItems: 'center',
    '& > i': {
      width: 14,
      height: 14,
      verticalAlign: 'unset !important'
    },
    '& > p': {
      paddingLeft: 20,
      marginBottom: 0,
      display: 'inline-block'
    }
  }
}).toString(); // ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------

/** DisqusComments */

var DisqusComments = function DisqusComments(props) {
  var pageData = props.pageData,
      data = props.data,
      _props$title = props.title,
      title = _props$title === undefined ? 'Leave a comment…' : _props$title,
      _props$titleClassname = props.titleClassname,
      titleClassname = _props$titleClassname === undefined ? '' : _props$titleClassname,
      _props$text = props.text,
      text = _props$text === undefined ? [_react2.default.createElement('p', null, 'Please share your thoughts and inspiration. Our hope is for these comments to create a space for collective wisdom to emerge.'), _react2.default.createElement('p', null, 'And a little request to please stay on topic and to keep your comments relevant and practical, so that other viewers are benefited.')] : _props$text,
      _props$collapsible = props.collapsible,
      collapsible = _props$collapsible === undefined ? true : _props$collapsible,
      _props$style = props.style,
      style = _props$style === undefined ? '' : _props$style;
  var disqusConfig = data.disqusConfig;
  var disqusShortname = disqusConfig.disqusShortname;
  var disqusConfigX = {
    url: '' + data.websiteUrl + pageData.nakedPageSlug,
    identifier: '' + data.websiteUrl + pageData.nakedPageSlug,
    title: pageData.pageTitle
  };
  return _react2.default.createElement(Fragment, null, collapsible === true ? _react2.default.createElement(_collapse2.default, {
    defaultActiveKey: ['9'],
    accordion: true,
    bordered: false,
    className: defaultStyle + ' ' + style
  }, _react2.default.createElement(Panel, {
    header: _react2.default.createElement('p', {
      className: titleClassname
    }, title),
    key: '1',
    showArrow: true
  }, _react2.default.createElement('aside', null, (0, _isArray2.default)(text) && _react2.default.createElement(Fragment, null, text), (0, _isString2.default)(text) && _react2.default.createElement('p', null, text), _react2.default.createElement('div', {
    className: 'mask-p'
  }, _react2.default.createElement(_disqusReact2.default.DiscussionEmbed, {
    shortname: disqusShortname,
    config: disqusConfigX
  }))))) : _react2.default.createElement('aside', {
    className: defaultStyle + ' ' + style
  }, _react2.default.createElement('p', {
    className: titleClassname
  }, title), (0, _isArray2.default)(text) && _react2.default.createElement(Fragment, null, text), (0, _isString2.default)(text) && _react2.default.createElement('p', null, text), _react2.default.createElement('div', {
    className: 'mask-p'
  }, _react2.default.createElement(_disqusReact2.default.DiscussionEmbed, {
    shortname: disqusShortname,
    config: disqusConfigX
  }))));
};

DisqusComments.propTypes = process.env.NODE_ENV !== "production" ? {
  pageData: _propTypes2.default.object,
  data: _propTypes2.default.object,
  title: _propTypes2.default.object,
  titleClassname: _propTypes2.default.object,
  text: _propTypes2.default.object,
  collapsible: _propTypes2.default.object,
  style: _propTypes2.default.object // ----------------------------------------------------------------------------
  // -------------------------------------------------------------------- Exports
  // ----------------------------------------------------------------------------

} : {};
exports.default = DisqusComments;
module.exports = exports['default'];